import React, {Dispatch, SetStateAction, SyntheticEvent, useEffect, useState} from 'react';

import './styles.css';
import urlBackend from '../../config-backend';


interface Props {
    onFileUploaded: (file: File) => void;
    selectedFile: File | undefined;
    currentUrl: string;
    setAudioDuration: Dispatch<SetStateAction<number>>
}

const RecordAudio: React.FC<Props> = ({onFileUploaded, selectedFile, currentUrl, setAudioDuration}) => {
    const [blobURL, setBlobURL] = useState('');

    useEffect(() => {
        if (selectedFile) {
            setBlobURL(URL.createObjectURL(selectedFile as Blob));
        } else {
            setBlobURL('');
        }
    }, [selectedFile]);

    useEffect(() => {
        if (currentUrl) {
            setBlobURL(urlBackend + '/uploads/' + currentUrl);
        }
    }, [currentUrl]);

    return (
        <div className="RecordAudio">
            <header className="RecordAudio-header">
                <audio src={blobURL} controls={true} onLoadedData={(e: SyntheticEvent<HTMLAudioElement>) => {
                    const audio: any = e.target;
                    setAudioDuration(Math.floor(audio.duration))
                }}/>
            </header>
        </div>
    );

}

export default RecordAudio;
